import Login from "./pages/login/Login";
import Logout from "./pages/logout/Logout";
import Register from "./pages/register/Register";
import {
  createBrowserRouter,
  RouterProvider,
  Route,
  Outlet,
  Navigate,
} from "react-router-dom";
import { GoogleMap, LoadScript, Marker, Circle } from '@react-google-maps/api';

import Navbar from "./components/navbar/Navbar";
import LeftBar from "./components/leftBar/LeftBar";
import RightBar from "./components/rightBar/RightBar";
import Notifications from "./components/notifications/Notifications.jsx";
import Home from "./pages/home/Home";
import Profile from "./pages/profile/Profile";
import Targets from "./pages/targets/Targets";
import TargetForm from "./pages/target_form/TargetForm";
import EventsPage from "./pages/events/EventsPage";
import Target from "./pages/target/Target";
import GeoPage from "./pages/geo/GeoPage";
import Cases from "./pages/cases/Cases";
import Case from "./pages/case/Case";
import CaseForm from "./pages/cases/CaseForm";
import OsintStats from "./pages/osint/Osint";
import SchedulesPage from "./pages/schedules/SchedulesPage";
import SettingsPage from "./pages/settings/Settings";
import "./style.scss";
import { useContext } from "react";
import { DarkModeContext } from "./context/darkModeContext";
import React, { useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { refreshToken } from './services/api';


function App() {
  const [auth, setAuth] = useState(false);
  const { darkMode } = useContext(DarkModeContext);

  useEffect(() => {
    const token = localStorage.getItem('access_token');
    if (token) {
      try {
        const decoded = jwtDecode(token);
        const currentTime = Date.now() / 1000;
        if (decoded.exp < currentTime) {
          // Token expired, try to refresh
          const refresh = localStorage.getItem('refresh_token');
          if (refresh) {
            refreshToken(refresh)
              .then((res) => {
                localStorage.setItem('access_token', res.data.access);
                setAuth(true);
              })
              .catch((err) => {
                console.error('Refresh token expired', err);
                setAuth(false);
              });
          } else {
            setAuth(false);
          }
        } else {
          setAuth(true);
        }
      } catch (err) {
        console.error('Invalid token', err);
        setAuth(false);
      }
    }
  }, []);

  const Layout = () => {
    return (
      <div className={`theme-${darkMode ? "dark" : "light"}`}>
        <Navbar setAuth={setAuth}/>
        <div style={{ display: "flex" }}>
          <LeftBar />
          <div style={{ flex: 6 }}>
            <Notifications /> 
            <Outlet />
          </div>
          <RightBar />
        </div>
      </div>
    );
  };

  const ProtectedRoute = ({ children }) => {
    if (!auth) {
      return <Navigate to="/login" />;
    }

    return children;
  };

  const router = createBrowserRouter([
    {
      path: "/",
      element: (
        <ProtectedRoute>
          <LoadScript
      googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
      libraries={['marker']} // Load the 'marker' library
    >
       <Layout />
    </LoadScript>
        </ProtectedRoute>
      ),
      children: [
        {
          path: "/",
          element: <Home />,
        },
        {
          path: "/settings",
          element: <SettingsPage />,
        },
        {
          path: "/schedules",
          element: <SchedulesPage />,
        },
        {
          path: "/geolocation",
          element: <GeoPage />,
        },
        {
          path: "/profile/:id",
          element: <Profile />,
        },
        {
          path: "/targets/new",
          element: <TargetForm />,
        },
        {
          path: "/edit-target/:id",
          element: <TargetForm />,
        },
        {
          path: "/edit-case/:id",
          element: <CaseForm />,
        },
        {
          path: "/cases/new",
          element: <CaseForm />,
        },
        {
          path: "/target/:id",
          element: <Target />,
        },
        {
          path: "/osint/:id",
          element: <OsintStats />,
        },
        {
          path: "/targets",
          element: <Targets />,
        },
        {
          path: "/events",
          element: <EventsPage />,
        },
        {
          path: "/cases",
          element: <Cases />,
        },{
          path: "/case/:id",
          element: <Case />,
        },
        {
          path: "/logout",
          element: <Logout setAuth={setAuth}/>,
        }
      ],
    },
    {
      path: "/login",
      element: auth ?  <Navigate to="/" /> : <Login setAuth={setAuth}/>,
    },
    {
      path: "/register",
      element: <Register />,
    },
    {
      path: "*",
      element: auth ? <Navigate to="/" /> : <Navigate to="/login" />,
    },
  ]);

  return (
    <div>
      <RouterProvider router={router} />
    </div>
  );
}

export default App;
